import { TFunction } from "i18next";

import { NotificationType } from "domain/notification";

export const assetImportNotificationTypes = [
    "ASSET_IMPORT_STARTED",
    "ASSET_IMPORT_SUCCEEDED",
    "ASSET_IMPORT_WARNING",
    "ASSET_IMPORT_FAILED",
] as const;

export type AssetImportNotificationType = (typeof assetImportNotificationTypes)[number];

export function isAssetImportNotificationType(
    notificationType: NotificationType | undefined
): notificationType is AssetImportNotificationType {
    return assetImportNotificationTypes.some((each) => each === notificationType);
}

export function getAssetImportTitleKey(notificationType: NotificationType | undefined, t: TFunction): string {
    switch (notificationType) {
        case "ASSET_IMPORT_STARTED":
            return t("Notification.title.assetManagement.import.started");
        case "ASSET_IMPORT_SUCCEEDED":
            return t("Notification.title.assetManagement.import.succeeded");
        case "ASSET_IMPORT_WARNING":
            return t("Notification.title.assetManagement.import.warning");
        case "ASSET_IMPORT_FAILED":
            return t("Notification.title.assetManagement.import.failed");
        default:
            return "";
    }
}
